<template>
    <div>
        <a class="flex px-4 py-2 text-red-700 hover:text-red-900 text-sm hover:bg-red-100 rounded" href="#" role="menuitem" @click.prevent="openModal">
            <svg aria-hidden="true" class="mr-3 w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                <path clip-rule="evenodd" d="M3 6a3 3 0 013-3h10a1 1 0 01.8 1.6L14.25 8l2.55 3.4A1 1 0 0116 13H6a1 1 0 00-1 1v3a1 1 0 11-2 0V6z" fill-rule="evenodd" />
            </svg>
            <span>Report</span>
        </a>
        <form-modal :show="show" @close="close">
            <template #title> Report Challenge </template>

            <template #content>
                <div class="flex flex-col">
                    <div class="flex gap-3 align-top">
                        <div class="flex-shrink-0 w-20 h-20 sm:w-32 sm:h-32 rounded overflow-hidden thumbnail-container" v-html="postThumb"></div>
                        <div class="text-sm sm:text-base text-gray-600">{{ postTitle }}</div>
                    </div>
                    <div class="min-w-0 flex-1 flex items-center mt-3">
                        <div class="w-full">
                            <label for="reportReason" class="block text-sm font-medium text-gray-700">Reason for reporting:</label>
                            <select id="reportReason" v-model="form.reason" class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md">
                                <option disabled value="">Please select a reason</option>
                                <option value="spam">Spam</option>
                                <option value="harassment">Harassment or Bullying</option>
                                <option value="hateSpeech">Hate Speech</option>
                                <option value="nudity">Nudity or Pornography</option>
                                <option value="violence">Violence or Graphic Content</option>
                                <option value="falseInfo">False Information</option>
                                <option value="intellectualProperty">Intellectual Property Violation</option>
                                <option value="illegalActivities">Illegal Activities</option>
                                <option value="selfHarm">Self-harm or Suicide</option>
                                <option value="personalInfo">Personal or Confidential Information</option>
                                <option value="impersonation">Impersonation</option>
                                <option value="threats">Threats or Terrorism</option>
                                <option value="other">Other</option>
                            </select>
                            <div v-if="form.errors.reason" class="text-red-500 text-sm mt-2">
                                {{ form.errors.reason }}
                            </div>
                            <textarea
                                v-if="form.reason"
                                v-model="form.details"
                                id="reportDetails"
                                rows="4"
                                class="mt-2 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm rounded-md"
                                placeholder="Additional details (optional)"
                            ></textarea>
                            <div v-if="form.errors.validation" class="text-red-500 text-sm mt-2">
                                {{ form.errors.validation }}
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template #footer>
                <div class="flex flex-row-reverse">
                    <danger-button class="ml-4" :focus="!!post" :processing="form.processing" @click.native="submit" :disabled="!isReasonSelected"> Report </danger-button>
                    <secondary-button @click.native="close"> Nevermind </secondary-button>
                </div>
            </template>
        </form-modal>
    </div>
</template>

<script>
import SecondaryButton from "@/Jetstream/SecondaryButton"
import DangerButton from "@/Jetstream/DangerButton"
import FormModal from "@/Components/FormModal"

export default {
    name: "ReportPost",
    components: { FormModal, DangerButton, SecondaryButton },

    props: {
        post: {
            default: null,
            type: Object,
        },
    },

    computed: {
        postThumb() {
            if (!this.post) return null
            return this.post.thumbs[0]
        },

        postTitle() {
            if (!this.post) return null
            return this.post.title
        },

        isReasonSelected() {
            return !!this.form.reason
        },
    },

    data() {
        return {
            form: this.$inertia.form({
                reason: "",
                details: "",
            }),
            show: false,
        }
    },

    methods: {
        submit() {
            const url = route("reports.store", { post: this.post.id })
            this.form.post(url, {
                onSuccess: () => {
                    this.close()
                    this.$emit("reported", true)
                    this.resetForm()
                },
                onError: () => {
                    // Handle errors, perhaps by showing error messages or highlighting invalid form fields
                },
            })
        },

        resetForm() {
            this.form.reset() // Reset form fields
        },

        close() {
            this.show = false
        },

        openModal() {
            this.show = true
        },
    },
}
</script>

<style scoped>
.thumbnail-container img {
    object-fit: cover; /* Cover the container without skewing */
    width: 100%; /* Fill the width of the container */
    height: 100%; /* Fill the height of the container */
}
</style>
